import { Trash } from "phosphor-react-sc"
import { CardTrailingActionsProps } from "../props/CardTrailingActionsProps"
import { useEffect, useState } from "react";

export const CardTrailingActions = ({
    cardService,
    dispatcherService,
}: CardTrailingActionsProps) => {

    const [width, setWidth] = useState<number>(0);
    const [className, setClassName] = useState<string>("");
    const [opacity, setOpacity] = useState<number>(0);

    useEffect(() => {
        cardService.onTrailingActionsWidthChange = setWidth;
        cardService.onTrailingActionsClassNameChange = setClassName;
        cardService.onTrailingActionsOpacityChange = setOpacity;
        return (() => {
            cardService.onTrailingActionsWidthChange = () => { };
            cardService.onTrailingActionsClassNameChange = () => { };
            cardService.onTrailingActionsOpacityChange = () => { };
        })
    }, []);

    return (
        <section
            className={`crd-trailing-actions ${cardService.classNameTrailingActions} ${className}`}
            style={{ width: width, opacity: opacity, marginLeft: (opacity > 0 && width < cardService.containerWidth) ? 5 : 0 }}>
            <div className="crd-action crd-trailing-actions-delete" onClick={(e: any) => dispatcherService.onDelete(e)}>
                <div className="crd-trailing-actions-delete-content">
                    <Trash weight="duotone" size={50} color="#ffffff" />
                </div>
            </div>
        </section>
    )
}
